import API from './api';

export default class FAQ extends API {}
